<template>
  <div ref="gantt"></div>
</template>

<script>
import 'dhtmlx-gantt'
import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_marker'
import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_undo.js'
import { cloneDeep } from 'lodash'

export default {
  name: 'gantt',
  props: {
    tasks: {
      type: Array
    },
    start: {
      required: true
    },
    end: {
      required: true
    }
  },
  data () {
    return {
      _tasks: cloneDeep(this.tasks)
    }
  },
  watch: {
    tasks: function(newVal, oldVal) { // watch it
      this._tasks = cloneDeep(newVal)

      var scroll = gantt.getScrollState()
      gantt.clearAll()

      gantt.addMarker({
        start_date: new Date(),
        css: "today",
        text: "Now",
        title: 'Today'
      })

      gantt.parse({ data: this._tasks })
      gantt.sort("start_date", false)
      gantt.scrollTo(scroll.x, scroll.y)
    }
  },
  methods: {
    initGantEvents () {
      if(gantt.$_eventsInitialized)
        return;
        gantt.attachEvent('onTaskSelected', (id) => {

        if (id) {
          let task = gantt.getTask(id)
          this.$emit('task-selected', task)
        }
      })
      gantt.attachEvent('onBeforeTaskChanged', (id, mode, task) => {
        this.$emit('task-changing', id, mode, task)

        return true
      })
      gantt.attachEvent('onAfterTaskUpdate', (id, task) => {

        this.$emit('task-updated', id, task)
      })
      gantt.attachEvent('onBeforeTaskDelete', (id, task) => {
        this.$emit('task-deleted', id)
        if(!gantt.getSelectedId()) {
          this.$emit('task-selected', null)
        }

        return true
      })
      gantt.attachEvent('onAfterLinkAdd', (id, link) => {
        this.$emit('link-updated', id, 'inserted', link)
      })
      gantt.attachEvent('onAfterLinkUpdate', (id, link) => {
        this.$emit('link-updated', id, 'updated', link)
      })
      gantt.attachEvent('onAfterLinkDelete', (id, link) => {
        this.$emit('link-updated', id, 'deleted')
      })
      gantt.attachEvent("onTaskDblClick", (id) => {

        if (id) {
          let task = gantt.getTask(id)
          this.$emit('task-edit', id, task)
        }

        return false;
      });
      gantt.attachEvent("onTaskCreated", (task) => {
        this.$emit('task-added', task)

        return false;
      });
      gantt.attachEvent("onBeforeLightbox", (id) => {
        return false; //don't show the lightbox
      });
    }
  },

  mounted () {
    this.initGantEvents()

    gantt.config.scale_unit = 'month'
    gantt.config.date_scale = "%F"
    gantt.config.step = 1
    gantt.config.scale_height = 44
    gantt.config.min_column_width = 30
    gantt.config.subscales = [
      {unit:"day", step:1, date:"%d"}
    ];
    gantt.config.order_branch = false
    gantt.config.drag_links = false
    gantt.locale.labels.section_type = "Type"
    gantt.locale.labels.section_confirmed = "Confirmed"
    gantt.config.work_time = true
    gantt.config.duration_unit = 'week'

    //add class to unconfirmed tasks to style
    gantt.templates.task_class = function(start, end, task) {
      let classes = []

      if (task.confirmed !== undefined && !parseInt(task.confirmed[0])) {
        if (task.stage_id) {
          classes.push(`unconfirmed-stage-${task.stage_id}`)
        }
      }

      if (!task.project_stage) {
        classes.push('non-project')
      }

      classes.push(`stage-${task.stage_id}`)

      return classes.join(' ')
    }

    //today marker line to show where we are at
    gantt.addMarker({
        start_date: new Date(),
        css: "today",
        text: "Now",
        title: 'Today'
    })

    //highlight cells with a different color for weekends
    gantt.templates.task_cell_class = (item,date) => {
      if (date.getDay() == 0 || date.getDay() == 6) {
          return "weekend"
      }
    }

    var taskName = function(start, end, task){
      return `<b>${ task.text }</b> - Stage ${ task.stage_id }`
    }

    gantt.templates.task_text = taskName

    var stages = [
        { key: 1, label: "Stage 1" },
        { key: 2, label: "Stage 2" },
        { key: 3, label: "Stage 3" }
    ];

    gantt.config.lightbox.sections = [
      { name:"description", height:38, map_to:"text", type:"textarea", focus:true },
      { name: "type", title: "Type", height: 22, map_to: "stage_id", type: "select", options: stages },
      { name: "confirmed", title: "Confirmed", height: 22, map_to: "confirmed", type: "checkbox", default_value: 0, options: [
        { key: 1, label: "Project Confirmed?" }
      ] },
      { name:"time", type:"duration", map_to:"auto", time_format:["%d","%m","%Y"] }
    ]

    //default columns definition
    gantt.config.columns = [
        {name:"text", label:"Project Name",  width:"*", tree: false },
        {name:"duration", label:"Duration",   align:"center" },
        {name:"add", label:"", width:44 }
    ];

    gantt.init(this.$refs.gantt, this.start, this.end)
    gantt.parse({ data: this.$props.tasks })
  }
}
</script>

<style>
  /* @import "~dhtmlx-gantt/codebase/dhtmlxgantt.css"; */
  @import "~dhtmlx-gantt/codebase/skins/dhtmlxgantt_material.css";

  .gantt_task_cell.weekend {
    background-color: #EFF5FD;
  }

  .gantt_task_line.non-project {
    /* opacity:0.7; */
  }

  .gantt_task_line.stage-1 {
    background-color: #1ab394 !important;
  }

  .gantt_task_line.stage-2 {
    background-color: #1571ea !important;
  }

  .gantt_task_line.stage-3 {
    background-color: #ed5565 !important;
  }

  .gantt_task_line.unconfirmed-stage-1 {
    background: repeating-linear-gradient(
      45deg,
      #1ab394,
      #1ab394 10px,
      #17a185 10px,
      #17a185 20px
    );
  }

  .gantt_task_line.unconfirmed-stage-2 {
    background: repeating-linear-gradient(
      45deg,
      #1571ea,
      #1571ea 10px,
      #0360dc 10px,
      #0360dc 20px
    );
  }

  .gantt_task_line.unconfirmed-stage-3 {
    background: repeating-linear-gradient(
      45deg,
      #ed5565,
      #ed5565 10px,
      #ca4452 10px,
      #ca4452 20px
    );
  }
</style>
